export function isTokenExpired(token) {
  if (!token) return true;
  const payload = token.split('.')[1];
  if (!payload) return true;
  try {
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return !decoded.exp || decoded.exp * 1000 <= Date.now();
  } catch (err) {
    return true;
  }
}
